import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

export const PageWrapper = styled.div`
  padding: 10px 5%; /* Increased side padding from 6% to 10% */
  background-color: aliceblue;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    padding: 16px 5%; /* Responsive padding for smaller screens */
  }
`;
